import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PostHogProvider } from 'posthog-js/react';

const options = {
  api_host: 'https://eu.i.posthog.com',
  defaults: '2025-05-24',
  person_profiles: 'identified_only',
  session_recording: {
    recordCrossOriginIframes: true,
  },
  autocapture: true,
  capture_pageview: true,
  capture_performance: true,
  capture_exceptions: true,
  debug: process.env.NODE_ENV === 'development',
  loaded: (posthog) => {
    if (process.env.NODE_ENV === 'development') posthog.debug();
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <PostHogProvider apiKey="phc_kwx3PTe70SgACmt33HRtKkGMAmrThs0umsdCnUxxTRz" options={options}>
        <App />
      </PostHogProvider>
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
